import { Component, Input, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { KeywordsService } from '../../utils/keywords.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IProjectHeader } from '../../interfaces/IProjectHeader';

@Component({
  selector: 'eic-project-header',
  templateUrl: './project-header.component.html',
  styleUrls: ['./project-header.component.scss']
})
export class ProjectHeaderComponent {
  @Input() projectHeader$: Observable<IProjectHeader>;
  @Input() discriminator: 'Project' | 'Asset';
  @Input() lifecycle: 'CAPEX' | 'OPEX' | 'ABEX';
  // template: any;
  template: TemplateRef<any>;

  @ViewChild('projectCapex', { static: true }) projectCapex: TemplateRef<any>;
  @ViewChild('projectOpex', { static: true }) projectOpex: TemplateRef<any>;
  @ViewChild('projectAbex', { static: true }) projectAbex: TemplateRef<any>;
  @ViewChild('assetCapex', { static: true }) assetCapex: TemplateRef<any>;
  @ViewChild('assetOpex', { static: true }) assetOpex: TemplateRef<any>;
  @ViewChild('assetAbex', { static: true }) assetAbex: TemplateRef<any>;


  searchTerm: string;
  sanitisedSearchTerm: SafeHtml;
  unsafeSearchTerm: string;

  constructor() { }

  //projectHeader.Discriminator, projectHeader.Lifecyclediscriminator: string, lifecycle: string
  ngOnChanges(changes: SimpleChanges) {
    // console.log(this.projectCapex);
    if (changes.discriminator || changes.lifecycle) {
      this.setTemplate();
    }
  }

  ngAfterViewInit() {
    // console.log(this.projectCapex);
    this.setTemplate();
  }


  setTemplate() {
    if (this.discriminator === 'Project') {
      switch (this.lifecycle) {
        case 'CAPEX':
          this.template = this.projectCapex;
          break;
        case 'OPEX':
          this.template = this.projectOpex;
          break;
        case 'ABEX':
          this.template = this.projectAbex;
          break;
      }
    } else if (this.discriminator === 'Asset') {
      switch (this.lifecycle) {
        case 'CAPEX':
          this.template = this.assetCapex;
          break;
        case 'OPEX':
          this.template = this.assetOpex;
          break;
        case 'ABEX':
          this.template = this.assetAbex;
          break;
      }
    }
  }
}


